<!--  -->
<template>
  <div class="test">
    <wx-open-launch-weapp
      id="launch-btn"
      username="gh_xxxxxxxx"
      path="pages/home/index?user=123&action=abc"
    >
  <template>
    <button class="btn">打开小程序</button>
  </template>
</wx-open-launch-weapp>
</div>
</template>

<script>
import wx from 'weixin-js-sdk';

export default {
  name: 'test',
  data() {
    return {};
  },
  mounted() {
    wx.config({
      debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
      appId: 'wxc83db38fafc573cf', // 必填，公众号的唯一标识
      timestamp: '', // 必填，生成签名的时间戳
      nonceStr: '', // 必填，生成签名的随机串
      signature: '', // 必填，签名
      jsApiList: [], // 必填，需要使用的JS接口列表
      openTagList: [], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
    });
    const btn = document.getElementById('launch-btn');
    btn.addEventListener('launch', () => {
      console.log('success');
    });
    btn.addEventListener('error', (e) => {
      console.log('fail', e.detail);
    });
  },
};
</script>
<style scoped></style>
